// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3GI0u","logo":"styles__logo___1S89Z","link":"styles__link___1ClL8"};